import { useCallback, useEffect, useState } from 'react';
import { getOpsCurrentUserByProviderId } from 'api/operation/group';
import { TCurrentUser } from 'types/group';

// OPS-only: resolve a provider's user (LoginResponse with practiceList) by providerId.
// No shared cache — OPS views different providers, so each mount fetches fresh for its own providerId.
const useOpsUserByProvider = (providerId?: number): [TCurrentUser | undefined, boolean, () => void] => {
    const [user, setUser] = useState<TCurrentUser>();
    const [loading, setLoading] = useState(false);

    const fetchUser = useCallback(async () => {
        if (providerId == null) return;
        setLoading(true);
        try {
            const result = await getOpsCurrentUserByProviderId(providerId);
            if (!result.error) {
                setUser(result?.data?.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [providerId]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return [user, loading, fetchUser];
};

export default useOpsUserByProvider;
